import { http } from './http';
import { unwrapSuccess } from './helpers';

export async function listNotifications(page, size, status="NEW") {
    const res = await http.get('/notifications', {
        params: status ? { page, size, status } : { page, size },
    });
    return unwrapSuccess(res);
}

export async function deleteNotifications(id) {
    return http.delete(`/notifications/${id}`);
}

export async function markRead() {
    return http.post(`/notifications/markRead`);
}
